// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ItuWRhckzTyxL-m6CHhfL {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n._2wSRqLKpt5TSKaI3JglsSv {\n    background-color: #FF6B78;\n    color: white;\n    font-size: x-small;\n    margin-left: 5px;\n}\n\n._1bNENnep6smXvA80tGOAd8 {\n    background-color: rgb(182, 182, 182);\n    color: rgb(102, 102, 102);\n    font-size: x-small;\n}\n\n._2wSRqLKpt5TSKaI3JglsSv:hover {\n    color: white;\n    cursor: default;\n    text-decoration: none;\n}\n\n._67A_6ayYoHW2wFSyXp9lW {\n    background-color: #f5fbfc;\n}\n", ""]);
// Exports
exports.locals = {
	"content": "ItuWRhckzTyxL-m6CHhfL",
	"skipContainer": "_2wSRqLKpt5TSKaI3JglsSv",
	"subsidyPill": "_1bNENnep6smXvA80tGOAd8",
	"highlightedRow": "_67A_6ayYoHW2wFSyXp9lW"
};
module.exports = exports;
